<template>
  <div v-if="list && list.length" class="container-padding">
    <div class="add-info__list">
      <div v-for="(item, i) in list" :key="i" class="add-info__item">
        <span v-if="item.title" class="add-info__item-title"> {{ item.title }} </span>
        <a :href="item.link" target="_blank" :class="{ 'no-hover': !item.link }" class="add-info__item-info">
          <span class="add-info__item-icon" v-html="item.icon"></span>
          <span v-if="item.description" class="add-info__item-description"> {{ item.description }} </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdditionalInfoComponent",
  props: {
    list: Array,
  },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/svg.styl"
.add-info {
  &__list {
    width 100%
    display flex
    border: 1px solid var(--main-color-75);
    border-radius: var(--main_radius)
    background var(--white)
    +below(990px) {
      flex-direction: column
    }
  }

  &__item {
    flex 1
    padding 15px 30px
    display flex
    flex-direction column
    gap 5px

    &-title {
      font-size: 0.875em
      line-height: 145%;
      color var(--dark_o5)
      margin-left: 30px
    }

    &-info {
      display: flex
      align-items: flex-start
      gap: 10px

      &.no-hover {
        cursor default
      }
    }

    &-icon {
      flex-shrink 0
      width: 20px
      height 20px

      svg {
        svg(--dark)
      }
    }

    &-description {
      font-weight: 700;
    }

    &:not(:last-child) {
      border-right 1px solid var(--main-color-75)
      +below(990px) {
        border-right: none
        border-bottom: 1px solid var(--main-color-75)
      }
    }
  }
}
</style>
